<template>
    <div>
        <el-tabs type="border-card" style="height: 850px;">
            <el-tab-pane label="岗位">
                <el-button plain type="success" style="float: left;margin: 0px 15px 5px;" @click="addPost">添加岗位</el-button>
                <el-table :data="response" style="margin:auto;width:calc(100% - 30px)" height="715" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                    :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="岗位名称" align="center" prop="name"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button plain type="success" size="small" @click="getFunction(scope.row.id)">查看权限</el-button>
                            <el-button plain type="success" size="small" @click="addPosition(scope.row)">添加职位</el-button>
                            <el-button plain type="success" size="small" @click="showPosition(scope.row.id)">查看职位</el-button>
                            <el-button plain type="success" size="small" @click="modifyInfo(scope.row)">修改信息</el-button>
                            <el-button plain type="success" size="small" @click="delPosition(scope.row.id)">删除岗位</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="自由人">开发中。。。</el-tab-pane>
        </el-tabs>
        <add-post v-if="addPostDialog" ref="addPost" @add-succeed="addSucceed"></add-post>
        <add-position v-if="addPositionDialog" ref="addPosition" @add-succeed="addSucceed"></add-position>
        <position v-if="positionDialog" ref="showPosition"></position>
        <modify v-if="modifyDialog" ref="modify" @modify-succeed="modifySucceed"></modify>
        <function v-if="functionDialog" ref="function"></function>
    </div>
</template>
<script>
import {postList,delPosition} from '../../api/sys/position.js'
import AddPost from './addPost.vue'
import AddPosition from './addPosition.vue'
import Position from './postion.vue'
import Modify from './modify.vue'
import Function from './function.vue'
export default { 
    components: {AddPost,AddPosition,Position,Modify,Function},
    name: 'Post',
    data() {
        return {
            addPostDialog: false,
            addPositionDialog: false,
            positionDialog: false,
            modifyDialog: false,
            functionDialog: false,
            response:[]
        }
    },
    methods: {
        getPost(){
            postList().then(result=>{
                this.response = result.data;
            })
        },
        addPost(){
            this.addPostDialog = true;
            this.$nextTick(()=>{
                this.$refs.addPost.init();
            })
        },
        addSucceed(){
            this.getPost();
        },
        addPosition(item){
            this.addPositionDialog = true;
            this.$nextTick(()=>{
                this.$refs.addPosition.init(item);
            })
        },
        showPosition(id){
            this.positionDialog = true;
            this.$nextTick(()=>{
                this.$refs.showPosition.init(id);
            })
        },
        modifyInfo(row){
            this.modifyDialog = true;
            let item = {
                id: row.id,
                name: row.name,
                roleGroupId: row.roleGroupId,
                functions: row.functionIds,
                type: "post"
            }
            this.$nextTick(()=>{
                this.$refs.modify.init(item);
            })
        },
        modifySucceed(){
            this.getPost();
        },
        delPosition(id){
        this.$confirm('确认是否操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            delPosition({id: id, type: "post"}).then(result=>{
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.getPost();
            })
            })
        },
        getFunction(id){
            this.functionDialog = true;
            this.$nextTick(()=>{
                this.$refs.function.init({id: id,type: "post"});
            })
        }
    },
    created(){
        this.getPost();
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/sys/post.vue